import React, { useState } from 'react'
import { CBadge, CSmartTable } from '@coreui/react-pro'
import { toast } from 'react-toastify'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import AdminAnnouncementService from 'src/service/AdminAnnouncementService'
import Notify from '../Notify'
import { stripHtml } from 'src/utils/html'

// The listing sorts and filters on real columns; payload.title is JSON and breaks both,
// so key the Title column on the title column the API also keeps in sync.
const columns = [
  { key: 'title', label: 'Title', filter: false, sorter: true },
  { key: 'created_at', label: 'Created', filter: false, sorter: true, _style: { width: '18%' } },
  { key: 'is_active', label: 'Status', filter: false, sorter: true, _style: { width: '14%' } },
  { key: 'actions', label: 'Actions', filter: false, sorter: false, _style: { width: '1%' } },
]

const Table = ({
  announcements,
  fetchAnnouncements,
  setActivePage,
  setItemsPerPage,
  itemsPerPage,
  activePage,
  setColumnSorter,
  onEditAnnouncement,
  listLoading,
}) => {
  const [loading, setLoading] = useState(false)

  const deleteAnnouncement = (id) => {
    setLoading(true)
    AdminAnnouncementService.deleteAnnouncement({ id })
      .then((res) => {
        if (res.status === 200) {
          toast.dismiss()
          fetchAnnouncements()
          ToastComponent(res.message, 'success')
        }
      })
      .finally(() => setLoading(false))
  }

  const handleStatus = (id, status) => {
    setLoading(true)
    AdminAnnouncementService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          toast.dismiss()
          fetchAnnouncements()
          ToastComponent(res.message, 'success')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
      .finally(() => setLoading(false))
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteAnnouncement(tableId)
    return setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    setShowConfirm(true)
    setTableId(id)
  }

  const totalPages = Math.ceil((announcements?.total || 0) / itemsPerPage)

  return (
    <div className="ge-datatable ge-datatable--no-select ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnSorter={{ external: true }}
        noItemsLabel="No announcements yet"
        scopedColumns={{
          title: (item) => {
            const preview = stripHtml(item.payload?.description || item.short_description)
            return (
              <td>
                <div className="an-title">
                  <span
                    className="an-title-main"
                    role="button"
                    onClick={() => onEditAnnouncement(item.id)}
                  >
                    {item.payload?.title || item.title || 'Untitled announcement'}
                  </span>
                  {preview && (
                    <span className="an-title-preview">
                      {preview.length > 120 ? `${preview.slice(0, 120)}…` : preview}
                    </span>
                  )}
                </div>
              </td>
            )
          },
          created_at: (item) => (
            <td>{item.created_at ? new Date(item.created_at).toLocaleDateString() : '-'}</td>
          ),
          is_active: (item) => (
            <td>
              <CBadge
                color={item.is_active === 1 ? 'success' : 'warning'}
                shape="rounded-pill"
                className="px-2 py-1"
              >
                {item.is_active === 1 ? 'Activated' : 'Deactivated'}
              </CBadge>
            </td>
          ),
          actions: (item) => (
            <td>
              <RowActionsMenu
                actions={[
                  { label: 'Edit', onClick: () => onEditAnnouncement(item.id) },
                  item.is_active === 1
                    ? { label: 'Deactivate', onClick: () => handleStatus(item.id, 0) }
                    : { label: 'Activate', onClick: () => handleStatus(item.id, 1) },
                  { label: 'Delete', danger: true, onClick: () => areYouSureModal(item.id) },
                ]}
              />
            </td>
          ),
        }}
        items={announcements?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading || listLoading}
        pagination={{ external: true }}
        paginationProps={{
          activePage,
          pages: totalPages || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(page) => setActivePage(page)}
        onItemsPerPageChange={(perPage) => {
          setActivePage(1)
          setItemsPerPage(perPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this announcement?"
      />
    </div>
  )
}

export default Table
